export default "__VITE_ASSET__e0f800e0__"